export default __webpack_public_path__ + "static/media/0043.79b593aa.png";